import { doc, runTransaction, increment, arrayUnion,updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getAuth } from "firebase/auth";

export const Incrementviews = async (postId) => {

     const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return; // skip if not signed in
  const postRef = doc(db, "feeddata", postId);
 
  try {
    await runTransaction(db, async (tx) => {
      const snap = await tx.get(postRef);
      if (!snap.exists()) throw new Error("Post not found");

      const { viewedBy = [] } = snap.data();
      if (!viewedBy.includes(user.uid)) {
        tx.update(postRef, {
          views: increment(1),
          viewedBy: arrayUnion(user.uid),
        });
      }
    });
       console("views done");
  } catch (error) {
    console.error("Failed to increment views:", error.message);
  }
};